import React, { FC, ReactElement, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import CarouselImageSlider from "./CarouselImageSlider/CarouselImageSlider";
import SliderBrands from "./SliderBrands/SliderBrands";
import PerfumeCardsSlider from "./PerfumeCardsSlider/PerfumeCardsSlider";
import { fetchHomeData } from "../../redux-toolkit/home/home-slice";
import { RootState } from "../../store";
import "./Home.css";

const Home: FC = (): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { data: homeData } = useSelector((state: RootState) => state.home);

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(fetchHomeData());
  }, [dispatch]);

  return (
    <div className="home-wrapper">

      {/* ── Hero Banner ── */}
      <div className="home-banner">
        <CarouselImageSlider items={homeData?.sliderItems || []} />
      </div>

      {/* ── Top Brands ── */}
      <section className="home-section">
        <div className="home-section-header">
          <h2 className="home-section-title">Top Brands</h2>
          <button
            className="home-section-link"
            onClick={() => history.push("/menu")}
          >
            View All →
          </button>
        </div>
        <div className="home-brands-section">
          <SliderBrands brands={homeData?.brands || []} />
        </div>
      </section>

      {/* ── Featured Products ── */}
      <section className="home-section">
        <div className="home-section-header">
          <h2 className="home-section-title">Featured Products</h2>
          <button
            className="home-section-link"
            onClick={() => history.push("/menu")}
          >
            View All →
          </button>
        </div>
        <div className="home-products-section">
          <PerfumeCardsSlider perfumes={homeData?.perfumes || []} />
        </div>
      </section>

    </div>
  );
};

export default Home;